<template>
	<div class="sans-serif container-lg links-container p-4">
		<h1 class="serif">Links to meeee:</h1>
		<template v-for="l in links" :key="l">
			<a class="link" :href="l.href"> 
				<div class="link-div p-4 m-4 serif">
					<i class="bi" :class="l['icon-class']"></i>
					{{ l.title }}
					<span class="d-none d-lg-inline">
						{{ l.more }}
					</span>
				</div>
			</a>
		</template>
	</div>
</template>

<script setup>
console.log("In links")
import links from "../data/links.json"
console.log(links)
</script>
<style>
.links-container {
	/* max-width: 70%; */
}
.link-div {
	border: 4px solid white;
	background-color: #6760fe;
	border-radius: 10px;
	transition:all 250ms;
	/* text-align: center; */
	font-size: 1.5rem;
}
.link-div:hover {
	/* background-color: #761ecf; */
	background-color: #0E97FA;
}
.link:not(:last-child),
.link-div:not(:last-child){
	margin-bottom: 0.5rem;
}

/* .link} */
</style>